export default __webpack_public_path__ + "static/media/640_dummy2016-consulting01-mobile-de.60a86d16.png";